import { render, staticRenderFns } from "./commentsReceived.vue?vue&type=template&id=8fc1d956&scoped=true&"
import script from "./commentsReceived.vue?vue&type=script&lang=js&"
export * from "./commentsReceived.vue?vue&type=script&lang=js&"
import style0 from "./commentsReceived.vue?vue&type=style&index=0&id=8fc1d956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc1d956",
  null
  
)

export default component.exports